import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const QA = [
  ["What is Joint Genesis?", "A daily dietary supplement for joint support, built around Mobilee® plus botanical extracts such as French maritime pine bark, boswellia, ginger and BioPerine®."],
  ["Where do I buy it?", "Through the official website linked on this page. Buying there means you get the genuine product and the maker's own guarantee terms."],
  ["Is there a money-back guarantee?", "The maker advertises a refund policy. Please read the exact terms and timeframe on the official order page before purchasing."],
  ["How long until I notice anything?", "It varies from person to person. Supplements are usually taken consistently over weeks; results are not guaranteed."],
  ["Is it safe for me?", "Check the full ingredient label and talk to your doctor first, especially if you are pregnant, nursing, take medication or have a medical condition."],
];

export const Faq = ({ items = QA }) => (
  <section id="faq" className="bg-[#F2EDE4] py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Questions</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#091D18] sm:text-5xl">
          Asked <span className="font-serif italic font-normal text-[#D96B43]">often.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {items.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-[#091D18]/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-semibold text-[#091D18] hover:no-underline sm:text-xl">
                {q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-base leading-relaxed text-[#091D18]/75">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
